"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function default_1(number, index) {
    return [
        ['just now', 'right now'],
        ['%ss ago', 'in %ss'],
        ['1m ago', 'in 1m'],
        ['%sm ago', 'in %sm'],
        ['1h ago', 'in 1h'],
        ['%sh ago', 'in %sh'],
        ['1d ago', 'in 1d'],
        ['%sd ago', 'in %sd'],
        ['1w ago', 'in 1w'],
        ['%sw ago', 'in %sw'],
        ['1mo ago', 'in 1mo'],
        ['%smo ago', 'in %smo'],
        ['1yr ago', 'in 1yr'],
        ['%syr ago', 'in %syr'],
    ][index];
}
exports.default = default_1;
//# sourceMappingURL=en_short.js.map